// src/routes/AppRoutes.js
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Loader from "../components/Loader/Loader";
import MainLayout from "../components/MainLayout/MainLayout";
import WithSplash from "../components/QuickTixSplash/WithSplash/WithSplash";
import AddEvent from "../components/MyEvents/AddEvent/AddEventMain/AddEvent";
import TicketDisplay from "../components/MyEvents/AddEvent/TicketDisplay/TicketDisplay";
import SettingsMain from "../Pages/Settings/index";
import AddRaffle from "../components/RaffleManagement/AddRaffle/AddRaffle";
import LoginPage from "../Pages/Login/index";
import SignUpPage from "../Pages/Signup/index";
import VerifyAccount from "../components/Authentication/VerifyAccount/VerifyAccount";
import ForgetPassword from "../components/Authentication/ForgetPassword/ForgetPassword";
import NewPassword from "../components/Authentication/CreateNewPassword/NewPassword";
import MainDetailPage from "../components/HomeLandingPage/Details/MainDetailPage";
import HomePage from "../Pages/LandingPage/index";
import MainSearchPage from "../components/HomeLandingPage/Search/MainSearchPage";
import TicketBooking from "../Pages/TicketBooking/index";
import TicketInvoice from "../Pages/TicketInvoice/index";
import VerifyCode from "../Pages/VerifyAlphaCode/index";
import TicketInfo from "../Pages/TicketInfo/index";
import QRCodeUpload from "../Pages/QRCodeUpload/index";
import ProtectedRoute from "../AppRoutes/ProtectedRoute";
import MyBookings from "../Pages/Bookings";
import AdminDashboard from "../Pages/Dashboard";
import EventInvites from "../Pages/Invites";
import RaffleManagementMain from "../Pages/Raffles";
import EventManagementMain from "../Pages/Events";
import AboutUs from "../components/HomeLandingPage/AboutUs/AboutUs";
import ContactUs from "../components/HomeLandingPage/ContactUs/ContactUs";
import TermsCondtions from "../Pages/TermsCondition";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import ExploreEventsPage from "../components/HomeLandingPage/Search/ExploreEventsPage";
import EventDetail from "../components/HomeLandingPage/Details/EventDetail/EventDetail";
import Reauth from "../components/Settings/PaymentIntegration/Reauth";
import Success from "../components/Settings/PaymentIntegration/Success";
import AlphaNumericTicketInfo from "../Pages/TicketInfo/AlphaNumericTicketInfo";
import VerifyName from "../Pages/VerifyByName";
import DetailByNameInfo from "../Pages/TicketInfo/DetailByNameInfo";
import TicketsDetails from "../Pages/Bookings/TicketsDetails";
import CreateTickets from "../Pages/Create Tickets/CreateTicketsScreen";
import ShowTemplates from "../Pages/Create Tickets/ShowTemplates";
import SelecetedTicket from "../Pages/Create Tickets/SelecetedTicket";
import AllTickets from "../Pages/Create Tickets/AllTickets";
import NotFound from "../components/NotFound/NotFound";
const SplashLoginPage = WithSplash(LoginPage);
const SplashSignUpPage = WithSplash(SignUpPage);
const SplashHomePage = WithSplash(HomePage);

const AppRoutes = () => (
  <Suspense fallback={<Loader />}>
    <Routes>
      {/*Landing Page Routes*/}
      <Route index element={<SplashHomePage />} />
      <Route path="search" element={<MainSearchPage />} />
      <Route path="about-us" element={<AboutUs />} />
      <Route path="contact" element={<ContactUs />} />
      <Route path="terms-conditions" element={<TermsCondtions />} />
      <Route path="privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/detail/:eventId" element={<MainDetailPage />} />
      <Route path="*" element={<NotFound />} />

      {/*Authentication Routes*/}
      <Route path="login" element={<SplashLoginPage />} />
      <Route path="register" element={<SplashSignUpPage />} />
      <Route path="verify-account" element={<VerifyAccount />} />
      <Route path="forget-password" element={<ForgetPassword />} />
      <Route path="create-new-password" element={<NewPassword />} />

      {/*Main Layout Protected Routes*/}
      {/* <Route element={<MainLayout />}> */}
      {/* uncomment this for Unprotected Route testing */}

      <Route element={<ProtectedRoute element={<MainLayout />} />}>
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="eventmanagement" element={<EventManagementMain />} />
        <Route path="add-event" element={<AddEvent />} />
        <Route path="ticket/:id" element={<TicketDisplay />} />
        <Route path="explore-events" element={<ExploreEventsPage />} />
        <Route path="/event-detailDesc/:eventId" element={<EventDetail />} />

       {/*  <Route path="/createtickets" element={<CreateTickets />} /> */}

        <Route path="show-templates" element={<ShowTemplates />} />
        <Route path="ticket-display" element={<SelecetedTicket />} />
        <Route path="all-tickets" element={<AllTickets />} />

        <Route path="mytickets" element={<MyBookings />} />
        <Route path="TicketsDetails" element={<TicketsDetails />} />
        <Route path="eventinvites/:eventId?" element={<EventInvites />} />
        <Route path="rafflemanagement" element={<RaffleManagementMain />} />
        <Route path="add-raffle" element={<AddRaffle />} />
        <Route path="settings" element={<SettingsMain />} />
        <Route path="ticket-booking" element={<TicketBooking />} />
        <Route path="ticket-invoice" element={<TicketInvoice />} />
        <Route path="verify-code" element={<VerifyCode />} />
        <Route path="verify-name" element={<VerifyName />} />
        <Route path="ticket-info" element={<TicketInfo />} />
        <Route path="ticket-information" element={<AlphaNumericTicketInfo />} />
        <Route path="DetailByNameInfo" element={<DetailByNameInfo />} />
        <Route path="QRCode-upload" element={<QRCodeUpload />} />
        <Route path="reauth" element={<Reauth />} />
        <Route path="success" element={<Success />} />
      </Route>
    </Routes>
  </Suspense>
);

export default AppRoutes;
